import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home/Home.vue";
import AuthError from "../views/AuthError.vue";
//AI智控交通
import AiTraffic from "../views/Home/AiTraffic.vue";
import SubstationAlarm from "../views/Home/Substation.vue";
//环境监测
import EnvMonitor from "../views/Home/EnvMonitor.vue";
import EnvDevice from "../views/Home/EnvDevice.vue";
import EnvAnalysis from "../views/Home/EnvAnalysis.vue";
import EnvHistory from "../views/Home/EnvHistory.vue";
import EnvMeter from "../views/Home/EnvMeter.vue";
import ChartGenerator from "../views/Home/ChartGenerator.vue";
//智慧宿舍
import VisualDormitory from "../views/Home/VisualDormitory.vue";
import DormitoryManage from "../views/Home/DormitoryManage.vue";
//权限管理
import Permission from "../views/Home/Permission.vue";
//智慧洗衣
import LaundryStatistics from "../views/Home/LaundryStatistics.vue"; //统计分析
import LaundryOrderManagement from "../views/Home/LaundryOrderManagement.vue"; //订单管理
import LaundryDeviceManagement from "../views/Home/LaundryDeviceManagement.vue"; //设备管理
import LaundryPushNotification from "../views/Home/LaundryPushNotification.vue"; //消息推送
import LaundryComplaintHandling from "../views/Home/LaundryComplaintHandling.vue"; //投诉处理
import LaundryUserManagement from "../views/Home/LaundryUserManagement.vue"; //用户管理
import LaundryPermissionManagement from "../views/Home/LaundryPermissionManagement.vue"; //权限管理
import LaundryReportManagement from "../views/Home/LaundryReportManagement.vue"; //报表管理
//水电表
import Engery from "../views/Home/engery/EngeryIndex.vue"
import EngeryMonior from "../views/Home/engery/EngeryMonior.vue"
import EngerySample from "../views/Home/engery/EngerySample.vue"
import EngeryManage from "../views/Home/engery/EngeryManage.vue"
import EngeryHistory from "../views/Home/engery/EngeryHistory.vue"
import EngeryRepair from "../views/Home/engery/EngeryRepair.vue"
import EngeryStatistics from "../views/Home/engery/EngeryStatistics.vue"

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash", // 使用 hash 模式
  routes: [
    {
      path: "/auth-error",
      component: AuthError
    },
    {
      path: "/home",
      component: Home,
      children: [
        {
          path: "traffic",
          component: AiTraffic
        },
        {
          path: "substation",
          component: SubstationAlarm
        },
        {
          path: "monitor",
          component: EnvMonitor
        },
        {
          path: "device",
          component: EnvDevice
        },
        {
          path: "analysis",
          component: EnvAnalysis
        },
        {
          path: "history",
          component: EnvHistory
        },
        {
          path: "history/chart",
          component: ChartGenerator
        },
        {
          path: "meter",
          component: EnvMeter
        },
        {
          path: "VisualDormitory",
          component: VisualDormitory
        },
        {
          path: "dormitory",
          component: DormitoryManage
        },
        {
          path: "permission",
          component: Permission
        },
        {
          path: "",
          redirect: "laundry-stats" // 默认跳转到智控交通
        },
        //新增智慧洗衣的界面
        {
          path: "laundry-stats",
          component: LaundryStatistics 
        },
        {
          path: "laundry-order",
          component: LaundryOrderManagement 
        },
        {
          path: "laundry-device",
          component: LaundryDeviceManagement 
        },
        {
          path: "laundry-notification",
          component: LaundryPushNotification 
        },
        {
          path: "laundry-complaint",
          component: LaundryComplaintHandling 
        },
        {
          path: "laundry-user",
          component: LaundryUserManagement 
        },
        {
          path: "laundry-permission",
          component: LaundryPermissionManagement 
        },
        {
          path: "laundry-report",
          component: LaundryReportManagement 
        },
        {
          path: "equipment",
          component: VisualDormitory // 暂时使用同一个组件
        },
        {
          path: "supervisor",
          component: VisualDormitory // 暂时使用同一个组件
        },
        {
          path: "engery",
          component: Engery
        },
        {
          path: "engery-monitor",
          component: EngeryMonior
        },
        {
          path: 'engery-sample',
          component: EngerySample
        },
        {
          path: 'engery-manage',
          component: EngeryManage
        },
        {
          path: 'engery-history',
          component: EngeryHistory
        },
        {
          path: 'engery-repair',
          component: EngeryRepair
        },
        {
          path: 'engery-statistics',
          component: EngeryStatistics
        }
      ]
    },
    {
      path: "/",
      redirect: "/home" // 根路径重定向到 ai-control
    },
  ]
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 如果是认证错误页面，直接放行
  if (to.path === "/auth-error") {
    next();
    return;
  }
  
  // 如果还没有进行认证，先尝试认证
  if (!store.state.isAuthenticated) {
    const authSuccess = await store.dispatch("initAuth");
    if (!authSuccess) {
      next("/auth-error");
      return;
    }
  }
  
  // 检查权限
  if (to.path.startsWith("/home")) {
    const module = to.path.split("/")[2]; // 获取子路由名称
    if (module && !store.getters.canAccessModule(module)) {
      // 如果没有权限访问该模块，重定向到有权限的第一个模块
      const availableModules = [];
      if (store.getters.hasPermission("aicontrol")) availableModules.push("traffic");
      if (store.getters.hasPermission("environmental")) availableModules.push("monitor");
      if (store.getters.hasPermission("hostel")) availableModules.push("VisualDormitory");
      if (store.getters.hasPermission("user")) availableModules.push("permission");
      if(store.getters.hasPermission("laundry")) availableModules.push("laundry-stats");
      if(store.getters.hasPermission("engery")) availableModules.push("engery");
      
      if (availableModules.length > 0) {
        next(`/home/${availableModules[0]}`);
      } else {
        next("/auth-error");
      }
      return;
    }
  }
  
  next();
});

export default router;
